import { Injectable } from '@angular/core';
import { AlertOptions, alertController } from '@bkkr/core';

import { OverlayBaseController } from '../util/overlay';

@Injectable({
  providedIn: 'root',
})
export class AlertController extends OverlayBaseController<AlertOptions, HTMLBkkrAlertElement> {
  constructor() {
    super(alertController);
  }
}
